import { Container, Sprite } from '@pixi/react'
import { Assets } from 'pixi.js'
import { useEffect, useRef, useState } from 'react'

interface ButtonProps {
  name: string
  x: number
  y: number
  width: number
  height: number
  enabled?: boolean
  visible?: boolean
  onPress: () => void
  defaultView: string
  pressedView?: string
  hoverView?: string
  disabledView?: string
  onHover?: () => void
  onHoverEnd?: () => void
  onPressing?: () => void
  onPressUp?: () => void
}

export const Button = ({
  enabled = true,
  visible = true,
  onHover,
  onHoverEnd,
  ...props
}: ButtonProps) => {
  const [currentAsset, setCurrentAsset] = useState('')
  const pressedRef = useRef(false)
  useEffect(() => {
    checkButtonAssets(props.defaultView, props.pressedView, props.hoverView, props.disabledView)
  }, [props.defaultView, props.pressedView, props.hoverView, props.disabledView])

  useEffect(() => {
    if (enabled) {
      setCurrentAsset(props.defaultView)
    }
    else {
      setCurrentAsset(props.disabledView ? props.disabledView : props.defaultView)
    }
  }, [enabled, props.defaultView, props.disabledView])

  if (!visible || currentAsset === '') return null

  return (
    <Container
      name={props.name}
      position={[props.x, props.y]}
      eventMode={enabled ? 'static' : 'none'}
      cursor={enabled ? 'pointer' : 'none'}
      pointerdown={() => {
        props.onPressing?.()
        if (props.pressedView) {
          setCurrentAsset(props.pressedView)
        }
        pressedRef.current = true
      }}
      pointerup={() => {
        setCurrentAsset(props.defaultView)
        if (props.hoverView) {
          setCurrentAsset(props.hoverView)
        }
        props.onPressUp?.()
        if (pressedRef.current) props.onPress()
        pressedRef.current = false
      }}
      pointerupoutside={() => {
        setCurrentAsset(props.defaultView)
        pressedRef.current = false
      }}
      pointerover={() => {
        if (props.hoverView) {
          setCurrentAsset(props.hoverView)
        }
        onHover?.()
      }}
      pointerout={() => {
        setCurrentAsset(props.defaultView)
        onHoverEnd?.()
        pressedRef.current = false
      }}
    >
      <Sprite image={currentAsset} width={props.width} height={props.height} />
    </Container>
  )
}
function checkButtonAssets(defaultView: string, pressedView?: string, hoverView?: string, disabledView?: string) {
  const hasButtonDefaultView = Assets.cache.has(defaultView.toString())
  if (!hasButtonDefaultView) console.warn('Button default view not found in assets', defaultView)
  if (pressedView) {
    const hasButtonPressedView = Assets.cache.has(pressedView.toString())
    if (!hasButtonPressedView) console.warn('Button pressed view not found in assets', pressedView)
  }
  if (hoverView) {
    const hasButtonHoverView = Assets.cache.has(hoverView.toString())
    if (!hasButtonHoverView) console.warn('Button hover view not found in assets', hoverView)
  }
  if (disabledView) {
    const hasButtonDisabledView = Assets.cache.has(disabledView.toString())
    if (!hasButtonDisabledView) console.warn('Button disabled view not found in assets', disabledView)
  }
}
